import React from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import './Sidebar.css';

// Generic sidebar chrome shared by every game. Game-specific brand label and
// nav items are passed in — see src/games/<game>/nav.js.
const Sidebar = ({ auth, brandLabel, navItems, isOpen, closeSidebar, userEmail, footerNote }) => {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out: ', error);
      alert('Failed to sign out.');
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2>{brandLabel}</h2>
        <button className="close-btn" onClick={closeSidebar}>×</button>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {navItems.map((item) => (
            <li key={item.to}>
              <Link to={item.to} onClick={closeSidebar}>{item.label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        {userEmail && <div className="signed-in-as">{userEmail}</div>}
        <button onClick={handleSignOut} className="signout-button">
          Sign Out
        </button>
        {footerNote && <p className="sidebar-footnote">{footerNote}</p>}
      </div>
    </div>
  );
};

export default Sidebar;
